import styled from 'styled-components';

export const CardContainer = styled.div`
  width: 90vw;
  margin: 3rem;

  .list-cards {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;

    @media (max-width: 768px) {
      justify-content: space-around;
      flex-direction: column;
    }
  }
`;

export const NavContainer = styled.div`
  border-bottom: solid 5px #009ee0;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .library-title {
    font-size: 40px;
    color: #009ee0;
    margin-bottom: 20px;
  }
`;
